import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../components/Expense/ExpList.css";
import SearchIcon from "@mui/icons-material/Search";
import Search from "../../../src/images/Search.png";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const PetCrateList = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  openAddProfile,
  setOpenAddProfile,
}) => {
  const [petCrates, setPetCrates] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  function HandleChange(param) {
    GetId(param);
  }

  function getStatusColor(status) {
    switch (status) {
      case true:
        return "#28A745"; // Green for active
      case false:
        return "#DC3545"; // Red for inactive
      default:
        return "white"; // Default color
    }
  }
  return (
    <div className="container-fluid">
      <div className="departmentList">
        <table>
          <thead>
            <tr className="departmentListHeading">
              <th>S No.</th>
              <th>Product Name</th>
        
              <th>Price</th>
              <th>Length</th>
              <th>Width</th>
              <th>Height</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {userDetailResponse != null ? (
              userDetailResponse.map((crate, index) => (
                <tr key={crate.Tseed}>
                  <td>{index + 1}</td>
                  <td>{crate.Crate_Type}</td>
                  <td>₹ {crate.Amount}</td>
                  <td>{crate.Lengths}</td>
                  <td>{crate.Width}</td>
                  <td>{crate.Height}</td>
                  <td>
                    <span style={{ color: getStatusColor(crate.Is_Active) }}>
                      {crate.Is_Active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td
                   
                      style={{
                       alignItems:"center",
                       padding:"8px",
                       textAlign:"center"
                      }}
                      onClick={() => {
                        HandleChange(crate.Tseed);
                        setOpenProfile(!openProfile);
                        setOpenAddProfile(false);
                      }}
                    >
                      <EditOutlinedIcon className="icon"
                      
                      style={{ cursor: "pointer" }}
/>
                    
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PetCrateList;
